import { PathLayer, PathLayerProps } from "@deck.gl/layers";
import { Position } from "geojson";
import { useSelector } from "react-redux";

import { XYLocation } from "@nens/deck-gl";

import { appDispatch } from "../../App";
import {
  getFinished,
  getLine,
  remove as removeProfileLine,
  setLine,
  setLineAndOpenWebsocket,
} from "../../state/mapProfileLine";

import { STATIC_COLORS } from "./DeckGlConsts";
import { DrawLine } from "./helpers/DrawLine";

// Line / Levee edit tool. Shown when the levee edit edit tool is open; what it does depends
// on Redux state.
const useLeveeEditTool = () => {
  const line = useSelector(getLine);
  const lineFinished = useSelector(getFinished);

  const setCallback = (points: XYLocation[]) => appDispatch(setLine(points));

  const removeLastPointCallback = () => {
    if (!line) return;
    if (line.length > 2) {
      appDispatch(setLine(line.slice(0, -1)));
    } else {
      appDispatch(removeProfileLine());
    }
  };

  const confirmDrawingCallback = () => {
    if (line) appDispatch(setLineAndOpenWebsocket(line));
  };

  const defaultPathLayerProps = {
    widthMaxPixels: 15,
    positionFormat: `XY`,
    _pathType: "open",
    opacity: 1,
    capRounded: true,
    jointRounded: true,
    getPath: (d: XYLocation) => d.flat().flat(),
    getWidth: 0.5,
    widthMinPixels: 1,
    pickable: false,
    getColor: STATIC_COLORS.LEVEE_EDIT,
  };

  return [
    new PathLayer({
      id: "dem-height-layer",
      data: line && lineFinished ? line : [],
      filled: true,
      extruded: true,
      getPolygon: (d: Position[]) => d.flat(),
      getFillColor: STATIC_COLORS.LEVEE_EDIT,
    }),
    ...DrawLine({
      id: "PROFILELINE",
      setCallback,
      confirmDrawingCallback,
      points: line || undefined,
      removeLastPointCallback,
      defaultPathLayerProps: defaultPathLayerProps as unknown as PathLayerProps,
      finished: lineFinished,
      isReadyToFinalizeConfirm: !!line && line.length > 1,
    }),
  ];
};

export default useLeveeEditTool;
